import { Component, ElementRef, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { UserService } from '../services/user.service';
import { GenInfoAtd, FileAttachement, AgendaDetails } from '../models/MOMForm';
import { MasterMOMService } from '../services/master-mom.service';
import { formatDate } from '@angular/common';
import { UtilityService } from '../services/utility.service';
import { ToastrUtilsService } from '../services/toastr-utils.service';
import Notiflix from "notiflix";
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';
import { ActivatedRoute, Params } from '@angular/router';
import { pairText } from '../models/users';
import { AdminService } from '../services/admin.service';

@Component({
  selector: 'app-delegate-meeting-minutes',
  templateUrl: './delegate-meeting-minutes.component.html',
  styleUrls: ['./delegate-meeting-minutes.component.css'],
  providers: [ToastrUtilsService]
})
export class DelegateMeetingMinutesComponent implements OnInit {

  @ViewChild('templateFile', { static: false }) templateFile: TemplateRef<any>;
  @ViewChild('template', { static: false }) template: TemplateRef<any>;

  modalRef: BsModalRef;
  modalPub: BsModalRef;
  modalPrivate: BsModalRef;
  modalMeeting: BsModalRef;
  modalImport: BsModalRef;
  filterCount: number = 0;
  viewSelected: boolean = true;
  editSelected: boolean = false;

  selTab1: boolean = true;
  selTab2: boolean = false;
  selTab3: boolean = false;
  selTab4: boolean = false;
  selTab5: boolean = false;

  momTab1: boolean = true;
  momTab2: boolean = false;
  momTab3: boolean = false;

  addTab1: boolean = true;
  addTab2: boolean = false;
  fileList: any = [];
  editDiv1: boolean = true;
  editDiv2: boolean = false;
  public text: string = 'Edit';
  loginUserId: any;
  meetingList: any = [];
  filterVal = new GenInfoAtd();
  today: any = new Date().toLocaleDateString();
  yesterday: any = new Date(new Date().setDate(new Date().getDate() - 1)).toLocaleDateString();
  disableMore: boolean;
  mid: any;
  noDataImage: string;
  isNodata: boolean;
  isLoader: boolean = false;
  actionType: any;
  sortByType: string = "date";
  public ngbModalOptions: any = {
    backdrop: 'static',
    keyboard: false
  };
  actionPointsList: any;
  attendeeDDList: any;
  created: boolean;
  review: boolean;
  approval: boolean;
  important: boolean;
  withDelay: boolean;
  assinedMe: boolean;
  publish: boolean;
  delegate: boolean;

  delay: boolean;
  reviewAssignedTodMe: boolean;
  approvalAssignedTodMe: boolean;
    DelegateUserID: any;
    Access: any;
    Delegate: any;
    strK1: string;
    strI1: string;
  constructor(private modalService: BsModalService,
    private userService: UserService,
    private toastr: ToastrUtilsService,
    public utilityService: UtilityService,
    private momService: MasterMOMService,
    private _activatedRoute: ActivatedRoute,
    public restApi: AdminService) { }

  @ViewChild('inputBox') inputBox: any;



  ngOnInit(): void {
    this.loadpairText();
    this.noDataImage = this.utilityService.getnodataImage();
    var user = this.userService.getUserInfo();

    if(user==undefined){
      this.userService.logout();
    }
    else{
    this.loginUserId = user.id;
    } 
    
    let that = this;
    setTimeout(function () {
   
      that._activatedRoute.queryParams.subscribe((params: Params) => {
      let QID = params['QId'];
      let QAccess = params['QAccess'];
      let QDelegate = params['QDelegate'];

        that.DelegateUserID = (QID != null && QID != '') ? atob(QID) : 0;
        that.Access = (QAccess != null && QAccess != '') ? atob(QAccess) : '';
        that.Delegate = (QDelegate != null && QDelegate != '') ? atob(QDelegate) : '';
        that.loginUserId = that.DelegateUserID != 0 && that.Access == 2 ? that.DelegateUserID : that.loginUserId;
        that.loadGeneralInfo();

    });
    }, 100);
   
    this.today = formatDate(this.today, 'MM/dd/yyyy', 'en-US');
    this.yesterday = formatDate(this.yesterday, 'MM/dd/yyyy', 'en-US');

    //jQuery('.hide-dropdown .dropdown-toggle').on('click', function (e) {
    //  $(this).next().toggle();
    //});
    //jQuery('.dropdown-menu.keep-open').on('click', function (e) {
    //  e.stopPropagation();
    //});



  }
  loadpairText() {
    ;
    let inpValue = new pairText();
    inpValue.k1 = '';
    this.restApi.callpairText(inpValue)
      .subscribe(data => {
        ;
        let rtnData: pairText;
        rtnData = data;
        this.strK1 = rtnData.k1;
        this.strI1 = rtnData.i1;
      },
        (error) => {
          //Called when error
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
      });
  }

  fireEvent(e) {
    this.inputBox.nativeElement.focus();
    e.stopPropagation();
    console.log('click inside input');
    return false;
  }

 

  loadGeneralInfo() {
    ;
    // Notiflix.Block.Dots('.pageloadcontainer');

    this.isLoader = true;
    this.filterVal.userUno = this.loginUserId;
    this.filterVal.delegateUserID = parseInt(this.DelegateUserID);
    this.filterVal.access = parseInt(this.Access);
    this.filterVal.delegate = parseInt(this.Delegate);
    this.filterVal.startIndex = (this.filterVal.startIndex == undefined || this.filterVal.startIndex < 1) ? 1 : this.filterVal.startIndex;
    this.filterVal.maxCount = 100;
    this.filterVal.varSortBy = this.sortByType;
    this.momService.getDelegateGeneralInfoAtd(this.filterVal)
      .subscribe((data: any) => {
        if (this.filterVal.startIndex == 1) {
          this.meetingList = data;
        }
        else {
          for (var i = 0; i < data.length; i++) {
            this.meetingList.push(data[i]);
          }
        }
        console.log(this.meetingList, "delegatemeeting");
        //if the result set is lessthen 100 then disable the load more icon
        this.disableMore = (data.length >= this.filterVal.maxCount) ? false : true;
        if (data.length > 0) {
          //this.ifcountgreaterthanzero = true;
          this.filterVal.startIndex = this.filterVal.startIndex + 1;

        }
        this.isLoader = false;
        // Notiflix.Block.Remove('.pageloadcontainer', 800);
      },
        () => {
          this.isLoader = false;
        }
      ).add(() => {
        this.isLoader = false;
        this.isNodata = true;
        // Notiflix.Block.Remove('.pageloadcontainer', 800);
        //Called when operation is complete (both success and error)

      });

  }


  followupMeeting(id: any) {
    Notiflix.Block.Dots('.pageloadcontainer');
    let inpValue = new GenInfoAtd();
    inpValue.userUno = this.loginUserId;
    inpValue.genInfoAtdUno = id;
    inpValue.actionType = "MFOLLOW";
    this.momService.createFollowupMeeting(inpValue)
      .subscribe((data: any) => {
        this.toastr.SuccessCustomMessage('Successfully Followup Created');
        Notiflix.Block.Remove('.pageloadcontainer', 800);
        this.filterVal.startIndex = 1;
        this.loadGeneralInfo();
      },
        () => {
          this.toastr.ErrorMessage();
          Notiflix.Block.Remove('.pageloadcontainer', 800);
        }
      ).add(() => {

      });
  }
  deleteMeeting(id: any) {
    let that = this;
    Notiflix.Confirm.Show('Confirm ', 'Are you sure you want to delete?', 'Yes', 'No', function () {
      Notiflix.Block.Dots('.pageloadcontainer');
      let inpValue = new GenInfoAtd();
      inpValue.userUno = that.loginUserId;
      inpValue.genInfoAtdUno = id;
      inpValue.actionType = "MEETING";
      that.momService.delGeneralInfoAtd(inpValue)
        .subscribe(data => {
          Notiflix.Block.Remove('.pageloadcontainer', 800);
          that.filterVal.startIndex = 1;
          that.toastr.DeleteMessage();
          that.loadGeneralInfo();
        },
          () => {
            that.toastr.ErrorMessage();
            Notiflix.Block.Remove('.pageloadcontainer', 800);
          }
        ).add(() => {
          Notiflix.Block.Remove('.pageloadcontainer', 800);
        });
    },
      function () { //('If you say so...');
      });
  }
  copyMeeting(id: any) {
    Notiflix.Block.Dots('.pageloadcontainer');
    let inpValue = new GenInfoAtd();
    inpValue.userUno = this.loginUserId;
    inpValue.genInfoAtdUno = id;
    inpValue.actionType = "MCOPY";

    this.momService.createFollowupMeeting(inpValue)
      .subscribe((data: any) => {
        this.toastr.SuccessCustomMessage('Successfully Meeting Copied');
        Notiflix.Block.Remove('.pageloadcontainer', 800);
        this.filterVal.startIndex = 1;
        this.loadGeneralInfo();
      },
        () => {
          this.toastr.ErrorMessage();
          Notiflix.Block.Remove('.pageloadcontainer', 800);
        }
      ).add(() => {
        Notiflix.Block.Remove('.pageloadcontainer', 800);
      });
  }
  getTodayMeeting() {
    return this.meetingList.filter(item => item.fMeetingDateAtd == this.today);
  }

  getYesterdayMeeting() {
    return this.meetingList.filter(item => item.fMeetingDateAtd == this.yesterday);
  }

  getOlderMeeting() {
    return this.meetingList.filter(item => item.fMeetingDateAtd != this.today && item.fMeetingDateAtd != this.yesterday);
  }

  openModal(template2: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template2, Object.assign({}, { class: 'gray modal-xl modal-full modal-dialog-scrollable modal-body-scrollable-hgt' }, this.ngbModalOptions)
    );
  }

  openModalnewMeeting(template1: TemplateRef<any>, item) {
    this.mid = item.genInfoAtdUno;
    this.modalMeeting = this.modalService.show(template1, Object.assign({}, { class: 'gray modal-xl modal-full modal-dialog-scrollable modal-body-scrollable' }, this.ngbModalOptions)
    );
  }
  openImport(importtemplate: TemplateRef<any>) {
    this.modalImport = this.modalService.show(importtemplate, Object.assign({}, { class: 'gray modal-xl modal-dialog-scrollable' }, this.ngbModalOptions));
    this.modalRef.hide();

  }
  openPubModal(template: TemplateRef<any>) {
    this.modalPub = this.modalService.show(template, Object.assign({}, { class: 'modal-md' }, this.ngbModalOptions));
    this.modalRef.hide();
  }
  openPrivateModal(templatePrivate: TemplateRef<any>) {
    this.modalPrivate = this.modalService.show(templatePrivate, Object.assign({}, { class: 'modal-md' }, this.ngbModalOptions));
    this.modalMeeting.hide();
  }
  dragDropConfig = {
    showList: true,
    showProgress: false
  }


  openFileModal(item) {
    this.mid = item.genInfoAtdUno;
    this.modalPub = this.modalService.show(this.templateFile, Object.assign({}, { class: 'modal-md' }, this.ngbModalOptions));
    this.getAttachFiles(this.mid);
  }
  exportXL() {
    let items: any = [];
    for (var i = 0; i < this.meetingList.length; i++) {
      items.push({
        Ref_Number: this.meetingList[i].momNoAtd,
        Type: this.meetingList[i].meetingName,
        Subject: this.meetingList[i].subjectAtd,
        MeetingDate: formatDate(this.meetingList[i].fMeetingDateAtd, 'MM/dd/yyyy', 'en-US'),
        StartTime: formatDate(this.meetingList[i].fStartTimeAtd, 'hh:mm a', 'en-US'),
        EndTime: formatDate(this.meetingList[i].fEndTimeAtd, 'hh:mm a', 'en-US'),
        Location: this.meetingList[i].locationName,
        MeetingRoom: this.meetingList[i].mkeetingRoomName,
        Status: this.meetingList[i].approvalStatus,
        Initiator: this.meetingList[i].initiatedBy
      });
    }
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(items);
    const workbook: XLSX.WorkBook = { Sheets: { 'Meeting': worksheet }, SheetNames: ['Meeting'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    FileSaver.saveAs(blob, 'MeetingList.xlsx');


  }

  onChangeEdit() {
    this.viewSelected = !this.viewSelected;
    this.editSelected = !this.editSelected;
    if (this.text === 'Edit') {
      this.text = 'Cancel'
    } else {
      this.text = 'Edit'
    };
  }
  profileCard() {
    let link: any = document.getElementById('profileDetails');
    link.classList.add('d-block');
  }

  closeCard() {
    let link: any = document.getElementById('profileDetails');
    link.classList.remove('d-block');
  }


  DownloadFiles(fileObj) {
    fileObj.actionType = 'MEETING';
    this.momService.downloadAttachFile(this.FileType(fileObj.fileName), fileObj);
  }

  getAttachFiles(id) {
    let inpValue = new FileAttachement();
    inpValue.generalInfoId = id;
    inpValue.attachmentUno = 0;
    inpValue.actionType = 'MEETING';
    this.momService.GetFileList(inpValue)
      .subscribe(data => {

        this.fileList = data;
      },
        () => {
          //Called when error
        }
      ).add(() => {
        //Called when operation is complete (both success and error)

      });
  }

  FileType(fileName) {
    //file type extension
    let checkFileType = fileName.split('.').pop();
    var fileType;
    if (checkFileType == "txt") {
      fileType = "text/plain";
    }
    if (checkFileType == "pdf") {
      fileType = "application/pdf";
    }
    if (checkFileType == "doc" || checkFileType == "docx") {
      fileType = "application/vnd.ms-word";
    }
    if (checkFileType == "pptx" || checkFileType == "ppt") {
      fileType = "application/vnd.ms-powerpoint";
    }
    if (checkFileType == "xls" || checkFileType == "xlsx") {
      fileType = "application/vnd.ms-excel";
    }
    if (checkFileType == "png") {
      fileType = "image/png";
    }
    if (checkFileType == "jpg") {
      fileType = "image/jpeg";
    }
    if (checkFileType == "jpeg") {
      fileType = "image/jpeg";
    }
    if (checkFileType == "gif") {
      fileType = "image/gif";
    }
    if (checkFileType == "csv") {
      fileType = "text/csv";
    }
    if (checkFileType == 'mp4' || checkFileType == 'm4a') {
      fileType = "video/mpeg";
    }
    return fileType
  }

  checkFileType(fileName) {


    //file type extension
    let checkFileType = fileName.split('.').pop();
    var fileType;
    if (checkFileType == "txt") {
      fileType = "la-file-text";
    }
    if (checkFileType == "pdf") {
      fileType = "la-file-pdf-o";
    }
    if (checkFileType == "doc" || checkFileType == "docx") {
      fileType = "la-file-word-o";
    }
    if (checkFileType == "pptx" || checkFileType == "ppt") {
      fileType = "la-file-powerpoint-o";
    }
    if (checkFileType == "xls" || checkFileType == "xlsx") {
      fileType = "la-file-excel-o";
    }
    if (checkFileType == "png") {
      fileType = "la-file-image-o";
    }
    if (checkFileType == "jpg") {
      fileType = "la-file-image-o";
    }
    if (checkFileType == "jpeg") {
      fileType = "la-file-image-o";
    }
    if (checkFileType == "gif") {
      fileType = "la-file-video-o";
    }
    if (checkFileType == "csv") {
      fileType = "la-file-o";
    }
    if (checkFileType == 'mp4' || checkFileType == 'm4a') {
      fileType = "la-file-video-o";
    }
    return fileType;
  }

  onChangemomTab(selectedTab: any) {
    ;
    if (selectedTab == 'general') {
      this.momTab1 = true;
      this.momTab2 = false;
      this.momTab3 = false;
    }
    else if (selectedTab == 'chat') {
      this.momTab1 = false;
      this.momTab2 = true;
      this.momTab3 = false;
    }
    else if (selectedTab == 'files') {
      this.momTab1 = false;
      this.momTab2 = false;
      this.momTab3 = true;
    }
    return false;
  }

  onChangesubTab(selectedTab: any) {
    ;
    if (selectedTab == 'internal') {
      this.addTab1 = true;
      this.addTab2 = false;
    }
    else if (selectedTab == 'external') {
      this.addTab1 = false;
      this.addTab2 = true;
    }
    return false;
  }

  onChangeTab(selectedTab: any) {

    if (selectedTab == 'details') {
      this.selTab1 = true;
      this.selTab2 = false;
      this.selTab3 = false;
      this.selTab4 = false;
      this.selTab5 = false;
    }
    else if (selectedTab == 'attendees') {
      this.selTab1 = false;
      this.selTab2 = true;
      this.selTab3 = false;
      this.selTab4 = false;
      this.selTab5 = false;
    }
    else if (selectedTab == 'Workflow') {
      this.selTab1 = false;
      this.selTab2 = false;
      this.selTab3 = true;
      this.selTab4 = false;
      this.selTab5 = false;
    }
    else if (selectedTab == 'actionspoints') {
      this.selTab1 = false;
      this.selTab2 = false;
      this.selTab3 = false;
      this.selTab4 = true;
      this.selTab5 = false;
    }
    else if (selectedTab == 'files') {
      this.selTab1 = false;
      this.selTab2 = false;
      this.selTab3 = false;
      this.selTab4 = false;
      this.selTab5 = true;
    }

    return false;
  }
  onChangeSortBy(value: any) {
    ;
    this.sortByType = value;
    this.filterVal.startIndex = 1;
    this.loadGeneralInfo();
  }
  //getMainActionPoints() {
  //  return this.actionPointsList.filter(item => item.agendaParentUno == 0);
  //}

  //getActionPointsList() {
  //  let inpValue = new AgendaDetails();
  //  inpValue.genInfoAtdUno = this.model.genInfoAtdUno;
  //  inpValue.userID = this.loginUserId;
  //  inpValue.startIndex = 1;
  //  inpValue.actionType = "MEETING";
  //  inpValue.maxCount = 100;
  //  this.momService.getAgendaDetails(inpValue)
  //    .subscribe((data: any) => {
  //      let numberList: any = [];
  //      this.attendeeDDList.forEach(function (item: any) {
  //        numberList.push(item.attendeesUnoAtd);
  //      });
  //      for (let i = 0; i < data.length; i++) {
  //        data[i].dueDate = (data[i].dueDate && data[i].dueDate != '') ? data[i].dueDate : null;
  //        //
  //        let UserList = (data[i].responsibility != null && data[i].responsibility != '') ? data[i].responsibility.split(',').map(Number) : null;
  //        if (UserList)
  //          data[i].responsibility = UserList.filter(item => numberList.includes(item))
  //      }
  //      this.actionPointsList = data;

  //    },
  //      () => {
  //        //Called when error

  //      }
  //    ).add(() => {
  //      //Called when operation is complete (both success and error)

  //    });
  //}

  getPopUpOutput(edit: boolean) {
    
    if (edit) {
      this.loadGeneralInfo();
    }
  }
}
